/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { IEventPurchase } from './purchases.interface';
import { CartPurchaseService } from './utils-components/cart/cart-purchase.service';

@Component({
  selector: 'pg-purchases-component',
  templateUrl: './purchases.component.html',
  providers: [MessageService]
})
export class PurchasesComponent {
  items: MenuItem[];
  activeIndex = 0;
  openSideBar = false;
  itemToSideBar: any;
  constructor(
    public messageService: MessageService,
    private cartPurchaseService: CartPurchaseService
  ) {}

  ngOnInit() {
    this.items = [
      {
        label: 'Seleccionar Proveedor'
      },
      {
        label: 'Detallar Documento'
      },
      {
        label: 'Seleccionar Productos'
      },
      {
        label: 'Confirmar Compra'
      }
    ];
  }

  onReceiveAction(event: IEventPurchase) {
    if (event.action === 'next') {
      this.activeIndex++;
    } else if (event.action === 'prev') {
      this.activeIndex--;
    } else if (event.action === 'success_purchase') {
      this.activeIndex = 0;
    }
  }

  onCloseSideBar() {
    this.openSideBar = false;
  }

  onItemToSideBar(event) {
    const { data } = event;
    if (data) {
      this.itemToSideBar = event.data;
      this.openSideBar = true;
    }
  }
}
